import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Angulartics2 } from 'angulartics2';
import { SeoService } from '../common/services/seo.service';

@Component({
  selector: 'app-about-page',
  templateUrl: './about-page.component.html',
  styleUrls: ['./about-page.component.scss']
})
export class AboutPageComponent implements OnInit {

  constructor(private titleService: Title, private angulartics2: Angulartics2, private meta: Meta, private seoService: SeoService) {
    this.seoService.setTitle('Despre - Fun Bible');
    this.seoService.setDescription('Hai să ne cunoști mai bine!');
    this.meta.updateTag({ property: 'og:url', content: 'https://funbible.net/about/' });
    this.meta.updateTag({ property: 'og:image', content: 'https://funbible.net/assets/logo.jpg' });
    const initialKeywords = ['educatie', 'proiect', 'jocuri ptr copii', 'jocuri online copii', 'melodii pentru copii', 'informatii', 'desene animate crestine', 'filme animate biblice', 'planse de colorat', 'fisa de colorat'].join();
    this.meta.updateTag({property: 'keywords', content: initialKeywords});
    this.angulartics2.eventTrack.next({
      action: 'About',
      properties: { category: 'pageView' },
    });
  }

  ngOnInit() {
  } 
}
